// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sprint-list[data-v-714ec75a] {\n  height: 100%;\n}\n.sprint-list .code-text[data-v-714ec75a] {\n  font-family: Consolas, Menlo, monospace;\n  font-size: 0.32rem;\n  color: var(--yq-font-color-desc);\n}\n.sprint-list .ellipsis[data-v-714ec75a] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
